import { PickingDetails, statusDict } from "api/wms/models";
import { MdiPoint } from "components/miloDesignSystem/atoms/icons/mdiPoint/MdiPoint";
import { Tag } from "components/miloDesignSystem/atoms/tag";
import { Typography } from "components/miloDesignSystem/atoms/typography";
import { RightPanelSection } from "components/utils/drawer";

interface Props {
  picking: PickingDetails;
}

export const TitleSection = ({ picking }: Props) => {
  return (
    <RightPanelSection padding="px-3 pt-2 pb-0">
      <div className="d-flex align-items-center gap-2">
        <Typography fontSize="26" fontWeight="700">
          {picking.signature}
        </Typography>
        <Tag
          startIcon={MdiPoint}
          label={statusDict[picking.status].label}
          variant={statusDict[picking.status].variant}
        />
        {picking.ramp && <Tag label={`Rampa ${picking.ramp?.name}`} variant="warning" />}
      </div>
    </RightPanelSection>
  );
};
